export default __webpack_public_path__ + "static/media/CB.68f33150.svg";